import { SubSink } from 'subsink';
import { AccountInformationService } from './../../../services/account-information/account-information.service';
import { AlertController, ModalController, ToastController } from '@ionic/angular';
import { PlatformService } from './../../../services/platform/platform.service';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IsUserLoggedInService } from 'src/app/services/user/is-user-logged-in.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-account-info',
  templateUrl: './account-info.page.html',
  styleUrls: ['./account-info.page.scss'],
})
export class AccountInfoPage implements OnInit {
  s3_url: string = environment.s3_bucket_url;

  isMobileDevice: boolean;
  accountInfoForm: FormGroup;
  subscription = new SubSink();
  showSpinner: boolean = false;

  isImage: boolean[] = [true, true];
  is_not_image_message = '';
  response_message: string = '';
  hasResponseError: boolean = false;

  profile_preview: string;
  cover_preview: string;

  isButtonDisabled: boolean = false;

  constructor(
    private fb: FormBuilder,
    private platform: PlatformService,
    private modalCtrl: ModalController,
    private toast: ToastController,
    private alertCtrl: AlertController,
    private accountInfoService: AccountInformationService,
    private loggedInService: IsUserLoggedInService,
    private auth: AuthService,
    public router: Router
  ) {
    this.isMobileDevice = this.platform.isMobile();
  }

  ngOnInit() {
    this.readyAccountInfoForm();
    this.getAccountInfoData();
  }

  ionViewWillLeave(){
    this.subscription.unsubscribe();
  }

  readyAccountInfoForm() {
    this.accountInfoForm = this.fb.group({
      profile_image: File,
      cover_image: File,
      crowd_following: [null, [Validators.pattern('^[0-9]*$')]],
      price_range_from: [null, [(control: AbstractControl) => Validators.max(this.accountInfoForm?.value.price_range_to)(control), Validators.pattern("^(?!-)[1-9][0-9]*(\.[0-9]+)?$|^0\.[0-9]*[1-9]+[0-9]*$")]],
      price_range_to: [null, [(control: AbstractControl) => Validators.min(this.accountInfoForm?.value.price_range_from)(control), Validators.pattern("^(?!-)[1-9][0-9]*(\.[0-9]+)?$|^0\.[0-9]*[1-9]+[0-9]*$")]],
      youtube_video_url: ['', [Validators.pattern('^https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()!@:%_\\+.~#?&\\/\\/=]*)')]],
      instagram: ['', [Validators.pattern('^https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()!@:%_\\+.~#?&\\/\\/=]*)')]],
      facebook: ['', [Validators.pattern('^https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()!@:%_\\+.~#?&\\/\\/=]*)')]],
      twitter: ['', [Validators.pattern('^https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()!@:%_\\+.~#?&\\/\\/=]*)')]],
      sound_cloud: ['', [Validators.pattern('^https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()!@:%_\\+.~#?&\\/\\/=]*)')]],
      spotify: ['', [Validators.pattern('^https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()!@:%_\\+.~#?&\\/\\/=]*)')]],
      google_calendar_url: ['', [Validators.pattern('^[^@]+@([-\\w]+\\.)+[A-Za-z]{2,4}$')]],
    });
  }

  readyFormData(res: any) {
    this.profile_preview = res?.profile_image ? this.s3_url + res.profile_image : null;
    this.cover_preview = res?.cover_image ? this.s3_url + res.cover_image : null;
    this.accountInfoForm.patchValue({
      crowd_following: res.crowd_following ?? null,
      price_range_from: res.price_range_from === null || res.price_range_from === "null" ? null : res.price_range_from,
      price_range_to: res.price_range_to === null || res.price_range_to === "null" ? null : res.price_range_to,
      youtube_video_url: res.youtube_video_url ?? '',
      instagram: res.instagram ?? '',
      facebook: res.facebook ?? '',
      twitter: res.twitter ?? '',
      sound_cloud: res.sound_cloud ?? '',
      spotify: res.spotify ?? '',
      google_calendar_url: res.google_calendar_url ?? '',
    });
  }

  // crowd_following_isInteger() {
  //   return (this.accountInfoForm.get('crowd_following').value % 1 === 0);
  // }

  get profile_image() {
    return this.accountInfoForm.get('profile_image');
  }

  get cover_image() {
    return this.accountInfoForm.get('cover_image');
  }

  get crowd_following() {
    return this.accountInfoForm.get('crowd_following');
  }

  get price_range_from() {
    return this.accountInfoForm.get('price_range_from');
  }

  get price_range_to() {
    return this.accountInfoForm.get('price_range_to');
  }

  get youtube_video_url() {
    return this.accountInfoForm.get('youtube_video_url');
  }

  get instagram() {
    return this.accountInfoForm.get('instagram');
  }

  get facebook() {
    return this.accountInfoForm.get('facebook');
  }

  get twitter() {
    return this.accountInfoForm.get('twitter');
  }

  get sound_cloud() {
    return this.accountInfoForm.get('sound_cloud');
  }

  get spotify() {
    return this.accountInfoForm.get('spotify');
  }

  get google_calendar_url() {
    return this.accountInfoForm.get('google_calendar_url');
  }

  price_range_validate() {
    if ((this.price_range_from.value === null && this.price_range_to.value === null) || (this.price_range_from.value === '' && this.price_range_to.value === '')) {
      this.accountInfoForm.controls['price_range_from'].clearValidators();
      this.accountInfoForm.controls['price_range_to'].clearValidators();
      this.accountInfoForm.get('price_range_from').setValue(null);
      this.accountInfoForm.get('price_range_to').setValue(null);
      this.accountInfoForm.controls['price_range_from'].setValidators([(control: AbstractControl) => Validators.max(this.accountInfoForm?.value.price_range_to)(control), Validators.pattern("^(?!-)[1-9][0-9]*(\.[0-9]+)?$|^0\.[0-9]*[1-9]+[0-9]*$")]);
      this.accountInfoForm.controls['price_range_to'].setValidators([(control: AbstractControl) => Validators.min(this.accountInfoForm?.value.price_range_from)(control), Validators.pattern("^(?!-)[1-9][0-9]*(\.[0-9]+)?$|^0\.[0-9]*[1-9]+[0-9]*$")]);
    } else if (this.price_range_from.value !== null || this.price_range_from.value !== '' || this.price_range_to.value !== null || this.price_range_to.value !== '') {
      this.accountInfoForm.controls['price_range_from'].setValidators([Validators.required, (control: AbstractControl) => Validators.max(this.accountInfoForm?.value.price_range_to)(control), Validators.pattern("^(?!-)[1-9][0-9]*(\.[0-9]+)?$|^0\.[0-9]*[1-9]+[0-9]*$")]);
      this.accountInfoForm.controls['price_range_to'].setValidators([Validators.required, (control: AbstractControl) => Validators.min(this.accountInfoForm?.value.price_range_from)(control), Validators.pattern("^(?!-)[1-9][0-9]*(\.[0-9]+)?$|^0\.[0-9]*[1-9]+[0-9]*$")]);
    }
    this.accountInfoForm.controls['price_range_from'].updateValueAndValidity();
    this.accountInfoForm.controls['price_range_to'].updateValueAndValidity();
  }

  uploadImage(event: any, identifier: string) {
    if (
      event.target.files &&
      event.target.files[0] &&
      event.target.files[0].type.includes('image/')
    ) {

      const reader = new FileReader();

      reader.onload = (_event: any) => {
        this.is_not_image_message = '';
        if (identifier === 'profile') {
          this.isImage[0] = true;
          this.profile_preview = _event.target.result;
        } else if (identifier === 'cover') {
          this.isImage[1] = true;
          this.cover_preview = _event.target.result;
        }

        this.accountInfoForm.get(`${identifier}_image`)?.setValue( event.target.files[0] );
        if (identifier === 'profile') {
          this.profile_image.markAsDirty();
        } else if (identifier === 'cover') {
          this.cover_image.markAsDirty();
        }

        console.log("account info form ==> ",this.accountInfoForm);

        // console.log('Image data --------> ', this.accountInfoForm.get(`${identifier}_image`).value);
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      if (identifier === 'profile') {
        this.isImage[0] = false;
        this.profile_preview = null;
      } else if (identifier === 'cover') {
        this.isImage[1] = false;
        this.cover_preview = null;
      }
      this.accountInfoForm.get(`${identifier}_image`)?.setValue(null);
      if (event.target.files[0] === undefined)
        this.is_not_image_message = "No image file selected";
      else
        this.is_not_image_message = "Only Image files can be uploaded";
    }
  }

  getAccountInfoData() {
    this.subscription.sink = this.accountInfoService
      .getAccountInfo()
      .subscribe(
        (res_accountInfo: any) => {
          this.readyFormData(res_accountInfo);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  updateAccountInfo() {
    this.showSpinner = true;
    let accountFormInfo = this.accountInfoForm.value;
    console.log('form data ---------->', accountFormInfo);
    var accountInfo: FormData = new FormData();
    accountInfo.append("profile_image", accountFormInfo?.profile_image);
    accountInfo.append("cover_image", accountFormInfo?.cover_image);
    if (accountFormInfo.crowd_following != null && accountFormInfo.crowd_following != "null")
      accountInfo.append("crowd_following", accountFormInfo.crowd_following);
    accountInfo.append("price_range_from", accountFormInfo.price_range_from);
    accountInfo.append("price_range_to", accountFormInfo.price_range_to);
    accountInfo.append("youtube_video_url", accountFormInfo.youtube_video_url);
    accountInfo.append("instagram", accountFormInfo.instagram);
    accountInfo.append("facebook", accountFormInfo.facebook);
    accountInfo.append("twitter", accountFormInfo.twitter);
    accountInfo.append("sound_cloud", accountFormInfo.sound_cloud);
    accountInfo.append("spotify", accountFormInfo.spotify);
    accountInfo.append("google_calendar_url", accountFormInfo.google_calendar_url);

    this.subscription.sink = this.accountInfoService
      .addAccountInfo(accountInfo)
      .subscribe(
        (res: any) => {
          this.showSpinner = false;

          let newProfileImg = res.data[0].profile_image;
          let newCoverImg = res.data[0].cover_image;
          this.updateProfileStorage(newProfileImg, newCoverImg);

          this.hasResponseError = false;
          this.response_message = res.message;
          this.presentSuccessToast(this.response_message);
        },
        (err: any) => {
          this.showSpinner = false;
          // console.log('Error ==> ', err);
          this.hasResponseError = true;
          this.response_message = "An error occurred adding your Account information, please try again later.";
          this.presentErrorToast(this.response_message);
        }
      );

  }


  updateProfileStorage(newProfileImg, newCoverImg) {
    let userProfile = JSON.parse(localStorage.getItem('user_profile'));
    userProfile.profile_image = newProfileImg;
    userProfile.cover_image = newCoverImg;
    localStorage.setItem('user_profile', JSON.stringify(userProfile));
  }

  async presentSuccessToast(res_message) {
    const toast = await this.toast.create({
      header: 'Success',
      color: 'success',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  async presentErrorToast(res_message) {
    const toast = await this.toast.create({
      header: 'Failed',
      color: 'danger',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  closeModal() {
    return this.modalCtrl.dismiss();
  }

  async presentDisableConfirm() {
    let alert = this.alertCtrl.create({
      // header: 'Disable Account',
      message: 'Are you sure, you want to disable your account?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            // console.log('Cancel clicked');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            // this.isBookingsLoading = true;
            this.enableDisableAccount();
            console.log('Account Deactivated');
          }
        }
      ]
    });
    (await alert).present();
  }

  enableDisableAccount() {
    this.isButtonDisabled = true;
    let data = {
      disable_status: 't'
    }
    this.subscription.sink = this.accountInfoService.enableDisableUserAccount(data).subscribe(
      (res) => {
        // console.log("account enable disable response ==> ",res);
        this.response_message = res.message;
        this.presentSuccessToast(this.response_message);
        this.logOut();
        this.isButtonDisabled = false;
      },
      (error) => {
        // console.log("account enable disable error ==> ",error);
        this.response_message = "A problem occurred disabling your account, please try again later.";
        this.presentErrorToast(this.response_message);
        this.isButtonDisabled = false;
      }
    );

  }

  async logOut(){
    this.loggedInService.changeUserStatus(0);
    await this.auth.logout();
    this.router.navigate(['home']);
  }
}
